var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTotalTestEnvironment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 4,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0703 9.1875H18.0312V12.625H24.0469L22.7148 9.61719C22.5859 9.35938 22.3281 9.1875 22.0703 9.1875ZM24.5625 14.6875H9.4375V23.625C9.4375 24.0117 9.73828 24.3125 10.125 24.3125H23.875C24.2188 24.3125 24.5625 24.0117 24.5625 23.625V14.6875ZM9.91016 12.625H15.9688V9.1875H11.8867C11.6289 9.1875 11.3711 9.35938 11.2852 9.61719L9.91016 12.625ZM22.0703 7.125C23.1445 7.125 24.1328 7.76953 24.5625 8.75781L26.3672 12.7969C26.5391 13.1406 26.625 13.5273 26.625 13.9141V23.625C26.625 25.1719 25.3789 26.375 23.875 26.375H10.125C8.57812 26.375 7.375 25.1719 7.375 23.625L7.375 13.9141C7.375 13.5273 7.41797 13.1406 7.58984 12.7969L9.39453 8.75781C9.82422 7.76953 10.8125 7.125 11.8867 7.125L22.0703 7.125Z",
    fill: "#808B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalTestEnvironment);
export default __webpack_public_path__ + "static/media/total-test-environment.c1fde48d137da78dc1b999f24b7878c4.svg";
export { ForwardRef as ReactComponent };